import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "FlightsFillGreenOnBlue__IconWrapper",
  componentId: "sc-17pb4ah-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 45 46",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    filter: "url(#FlightsFillGreenOnBlue_tsx__a)"
  }, React.createElement("mask", {
    id: "FlightsFillGreenOnBlue_tsx__b",
    width: 23,
    height: 23,
    x: 15.803,
    y: 4.669,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M15.803 4.669h23v23h-23z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "m21.473 5.875-.103-.08a.8.8 0 0 0-.49-.124.8.8 0 0 0-.494.229l-.116.123-2.467 2.466 4.816 1.46 1.113-1.208a.86.86 0 0 0-.035-.596l-.066-.11zM35.295 19.69l-.144-.092c-.174-.089-.884.399-1.38.74-.215.146-.39.266-.464.3l1.458 4.815 2.528-2.523.094-.09a.8.8 0 0 0 .197-.465.8.8 0 0 0-.112-.476l-.066-.09z",
    clipRule: "evenodd"
  })), React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    fillRule: "evenodd",
    d: "m21.473 5.875-.103-.08a.8.8 0 0 0-.49-.124.8.8 0 0 0-.494.229l-.116.123-2.467 2.466 4.816 1.46 1.113-1.208a.86.86 0 0 0-.035-.596l-.066-.11zM35.295 19.69l-.144-.092c-.174-.089-.884.399-1.38.74-.215.146-.39.266-.464.3l1.458 4.815 2.528-2.523.094-.09a.8.8 0 0 0 .197-.465.8.8 0 0 0-.112-.476l-.066-.09z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.pricePrimary.dark")(themeProps),
    d: "m21.37 5.796.61-.792-.032-.025-.035-.023zm.103.079.707-.707-.046-.046-.051-.04zm-1.087.025-.68-.733-.025.023-.023.024zm-.116.123.706.708.011-.01.01-.012zM17.803 8.49l-.707-.708-1.18 1.18 1.597.485zm4.816 1.46-.29.957.6.181.425-.46zm1.113-1.208.735.677.161-.174.065-.229zm-.035-.596.905-.426-.021-.045-.026-.043zm-.066-.11.858-.515-.064-.105-.087-.088zm11.52 11.563.537-.843-.04-.026-.042-.021zm.144.092.709-.706-.079-.079-.093-.059zm-1.525.647.566.825zm-.463.302-.42-.908-.79.365.253.833zm1.458 4.814-.957.29.483 1.595 1.18-1.178zm2.528-2.523-.691-.723-.008.008-.007.007zm.094-.09.69.724.03-.029.028-.03zm.197-.465.997.076zm-.112-.476.852-.524-.023-.038-.026-.035zm-.066-.09.802-.596-.043-.058-.05-.051zM20.76 6.59l.102.078 1.221-1.584-.103-.08zm.196.08a.2.2 0 0 1-.13-.034l1.087-1.679a1.8 1.8 0 0 0-1.109-.282zm.11-.036c.01-.009.002 0-.025.013a.3.3 0 0 1-.085.022l-.152-1.994c-.42.032-.791.208-1.098.493zm-.069.076.117-.123-1.456-1.372-.116.124zM18.51 9.196l2.466-2.465-1.413-1.415-2.467 2.465zm4.399-.205-4.816-1.46-.58 1.915 4.815 1.46zm.087-.928-1.113 1.208 1.47 1.355 1.114-1.208zm-.204.507a.2.2 0 0 1-.023-.082q-.001-.02.001-.021l1.923.548a1.86 1.86 0 0 0-.091-1.296zm-.019-.022.066.11 1.716-1.027-.066-.11zm-2.008-1.966 2.159 2.16 1.414-1.415-2.158-2.159zm13.85 13.86.143.091 1.074-1.687-.144-.091zm-.279.72c.256-.176.527-.361.752-.493.115-.068.182-.1.207-.11.013-.004-.02.01-.087.02a.86.86 0 0 1-.512-.09l.91-1.781a1.14 1.14 0 0 0-.69-.107c-.14.02-.262.062-.347.095a3.6 3.6 0 0 0-.493.248c-.298.175-.631.404-.872.569zm-.61.385c.118-.055.243-.137.31-.182.09-.059.195-.131.3-.203l-1.132-1.65a20 20 0 0 1-.343.231c-.022.014-.008.004.026-.012zm1.996 3.616-1.458-4.814-1.914.58 1.458 4.814zm.865-2.94-2.528 2.522 1.412 1.415L38 23.639zm.109-.105-.094.09 1.382 1.445.094-.09zm-.11.181a.2.2 0 0 1 .053-.122l1.496 1.328c.258-.291.416-.661.446-1.054zm.035.124a.2.2 0 0 1-.03-.068.2.2 0 0 1-.004-.056l1.994.152a1.8 1.8 0 0 0-.257-1.076zm-.018-.017.067.09 1.605-1.194-.067-.09zm-2.017-2.01 2.111 2.119 1.417-1.411-2.11-2.12z",
    mask: "url(#FlightsFillGreenOnBlue_tsx__b)"
  }), React.createElement("path", {
    fill: themeGet("palette.text.heading")(themeProps),
    d: "M39.748 3.104c-.45-.2-.936-.306-1.427-.312l-.674.017c-2.13.1-3.884 1.076-6.186 3.172l-.714.669-.949.934-3.415 3.505-2.247-.68-8.052-2.441-6.97-2.111-.221-.054a2.09 2.09 0 0 0-1.846.563l-.865.865-.145.158a1.77 1.77 0 0 0-.38 1.383l.045.21c.132.478.46.882.909 1.11l13.517 7.354-2.988 3.005-.674.654a32.5 32.5 0 0 0-3.072 3.553l-7.091-.561-.19.005a1.32 1.32 0 0 0-.79.345l-.878.877-.122.14a1.378 1.378 0 0 0 .458 2.055l5.471 2.75a2.64 2.64 0 0 0 .593 2.127l.133.124.225.15a2.63 2.63 0 0 0 1.781.33l2.745 5.462.1.163a1.377 1.377 0 0 0 2.102.183l.854-.854.118-.144c.178-.247.265-.529.257-.818l-.55-7.128a32.6 32.6 0 0 0 4.227-3.736l2-1.977.99-.99 7.347 13.503.104.178a1.773 1.773 0 0 0 2.745.23l.86-.86.151-.171a2.09 2.09 0 0 0 .364-1.899l-2.113-6.973-2.438-8.048-.678-2.233 3.3-3.233 1.076-1.09.509-.54c2.12-2.303 3.27-4.272 3.391-6.463l.018-.66a3.6 3.6 0 0 0-.313-1.396.8.8 0 0 0-.402-.402"
  }), React.createElement("mask", {
    id: "FlightsFillGreenOnBlue_tsx__c",
    width: 30,
    height: 30,
    x: 6.223,
    y: 6.351,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M6.223 6.351h30v30h-30z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "m30.894 18.138 4.99 16.462.02.106a.5.5 0 0 1-.077.306l-.068.086-.865.866-.056.044-.06.022h-.06l-.057-.018-.049-.035-.02-.022-7.596-13.959 2.248-2.237zM8.55 7.352l.108.02 16.484 4.994-1.957 2.01-1.892 1.9L7.348 8.69l-.064-.044a.18.18 0 0 1-.06-.109.2.2 0 0 1 .02-.117l.037-.048.882-.881.083-.065a.5.5 0 0 1 .304-.074",
    clipRule: "evenodd"
  })), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "m30.894 18.138 4.99 16.462.02.106a.5.5 0 0 1-.077.306l-.068.086-.865.866-.056.044-.06.022h-.06l-.057-.018-.049-.035-.02-.022-7.596-13.959 2.248-2.237zM8.55 7.352l.108.02 16.484 4.994-1.957 2.01-1.892 1.9L7.348 8.69l-.064-.044a.18.18 0 0 1-.06-.109.2.2 0 0 1 .02-.117l.037-.048.882-.881.083-.065a.5.5 0 0 1 .304-.074",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    d: "m30.894 18.138.24-.073-.12-.395-.295.29zm4.99 16.462.245-.046-.002-.014-.004-.013zm.02.106.248-.019v-.013l-.003-.013zm-.077.306.196.155.009-.01.007-.012zm-.068.086.177.177.01-.01.01-.012zm-.865.866.155.196.011-.01.01-.01zm-.056.044.087.234.037-.014.03-.024zm-.12.023-.076.238.04.012h.04zm-.057-.019-.147.203.033.023.038.013zm-.049-.035-.19.163.02.023.024.017zm-7.616-13.98-.176-.178-.133.132.09.165zm2.248-2.238-.176-.179v.001zM8.55 7.352l.046-.245-.013-.003H8.57zm.108.02.072-.239-.013-.004-.013-.002zm16.484 4.994.179.175.287-.295-.394-.119zm-1.957 2.01.178.176.002-.002zm-1.892 1.9-.12.22.165.089.132-.133zM7.348 8.69l-.14.206.01.007.01.006zm-.064-.044-.169.185.014.012.015.01zm-.04-.226-.2-.15-.011.016-.01.018zm.037-.048-.177-.177-.012.013-.01.014zm.882-.881-.154-.197-.012.01-.011.01zm.083-.065-.132-.213-.012.007-.01.009zM30.655 18.21l4.99 16.462.478-.145-4.99-16.462zm4.983 16.435.02.106.491-.09-.02-.107zm.016.08a.26.26 0 0 1-.039.155l.424.265a.76.76 0 0 0 .114-.458zm-.023.133-.068.085.393.31.067-.086zm-.048.063-.866.866.354.353.865-.865zm-.844.846-.056.044.31.393.056-.044zm.012.006-.06.022.175.469.06-.022zm.024.007h-.061l.008.5h.061zm.019.012-.057-.018-.152.477.057.018zm.013.018-.048-.035-.293.405.048.035zm-.005.005-.02-.023-.38.325.02.023zm.01.02-7.596-13.958-.44.239 7.597 13.958zm-7.64-13.662 2.248-2.237-.353-.355-2.247 2.238zm2.247-2.236 1.65-1.621-.35-.357-1.65 1.621zM8.505 7.598l.107.02.092-.491-.108-.02zm.08.014 16.484 4.994.145-.479L8.73 7.133zm16.378 4.58-1.957 2.01.358.348 1.957-2.01zm-1.955 2.007-1.892 1.9.354.353 1.893-1.9zm-1.596 1.857L7.467 8.47l-.239.44 13.945 7.585zM7.488 8.483l-.063-.043-.281.413.063.043zm-.035-.02.011.014a.1.1 0 0 1 .008.023l-.494.074a.43.43 0 0 0 .137.257zm.019.037a.06.06 0 0 1-.006.037l-.442-.233a.44.44 0 0 0-.046.27zm-.028.07.037-.047-.4-.301-.036.048zm.014-.021.881-.882-.353-.353-.882.881zm.859-.861.083-.065-.308-.394-.083.065zm.06-.05a.26.26 0 0 1 .154-.036l.039-.499a.76.76 0 0 0-.456.11z",
    mask: "url(#FlightsFillGreenOnBlue_tsx__c)"
  }), React.createElement("mask", {
    id: "FlightsFillGreenOnBlue_tsx__d",
    width: 14,
    height: 14,
    x: 4.766,
    y: 24.684,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M4.766 24.684h14v14h-14z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    d: "m12.336 26.165-6.013-.481-.557.557 5.038 2.532.206-.424.424-.74q.432-.735.902-1.444m5.23 10.767-.463-6.018-.71.454a33 33 0 0 1-1.46.854 11 11 0 0 1-.456.225l2.532 5.042z",
    clipRule: "evenodd"
  })), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    fillRule: "evenodd",
    d: "m12.336 26.165-6.013-.481-.557.557 5.038 2.532.206-.424.424-.74q.432-.735.902-1.444m5.23 10.767-.463-6.018-.71.454a33 33 0 0 1-1.46.854 11 11 0 0 1-.456.225l2.532 5.042z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.tint")(themeProps),
    d: "m6.323 25.684.02-.25-.115-.009-.082.082zm6.013.48.208.138.234-.353-.422-.034zm-6.57.077-.177-.177-.245.245.31.155zm5.038 2.532-.113.223.226.114.111-.227zm.206-.424-.217-.123-.004.007-.003.007zm.424-.74-.216-.127-.002.003zm5.669 3.305.25-.019-.033-.416-.352.225zm.464 6.018.177.176.081-.08-.009-.115zm-1.175-5.564.132.213.003-.002zm-1.458.854.116.222.005-.003zm-.457.225-.106-.226-.234.108.116.23zm2.532 5.042-.223.112.155.31.245-.245zM6.304 25.933l6.013.48.04-.498-6.013-.48zm-.36.485.557-.557-.354-.354-.557.557zm4.973 2.131-5.038-2.531-.225.447 5.039 2.531zm-.13-.31-.207.424.45.22.206-.424zm.43-.754-.423.74.434.249.424-.74zm.911-1.458a33 33 0 0 0-.909 1.455l.431.254q.43-.729.895-1.434zm4.727 4.907.464 6.017.498-.038-.464-6.018zm-.327.645.71-.454-.268-.421-.711.453zm-1.472.862a33 33 0 0 0 1.47-.86l-.264-.425q-.712.441-1.448.847zm-.473.233q.233-.109.467-.23L14.82 32q-.226.117-.448.22zm2.65 4.703L14.7 32.335l-.447.225 2.533 5.041zm.158-.622-.557.557.353.354.558-.557z",
    mask: "url(#FlightsFillGreenOnBlue_tsx__d)"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    fillRule: "evenodd",
    d: "m38.308 4.377.214.015.204.034.08.022.044.176.022.163.008.166-.015.5c-.104 1.665-.98 3.25-2.636 5.123l-.341.379-.65.685-.882.89-6.534 6.407-5.156 5.139-.956.941-.61.624a31 31 0 0 1-6.913 5.186l-.356.176-.371.163-.563.221-.18.044q-.267.044-.503-.032l-.152-.063-.062-.04-.044-.06c-.172-.286-.199-.641-.064-.954.162-.432.33-.817.519-1.192a31 31 0 0 1 5.211-6.9l.626-.607 6.342-6.375.805-.82 5.339-5.496.372-.375.36-.357.69-.661.387-.357c1.904-1.724 3.35-2.566 4.943-2.73l.32-.024z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: themeGet("palette.highlight.light")(themeProps),
    fillRule: "evenodd",
    d: "M37.512 5.685a1.88 1.88 0 0 0-2.658 0 .436.436 0 0 0-.002.613c.167.17.44.171.608.003.32-.32.797-.384 1.18-.192l.138.084.122.103.053.068a1.02 1.02 0 0 1 0 1.448.435.435 0 0 0-.004.613c.167.17.44.172.609.004a1.89 1.89 0 0 0 .266-2.35l-.123-.172-.14-.157z",
    clipRule: "evenodd"
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "FlightsFillGreenOnBlue_tsx__a",
    width: 48,
    height: 48,
    x: -1.75,
    y: -1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 2
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.12 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_5665"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: 1
  }), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.16 0"
  }), React.createElement("feBlend", {
    in2: "effect1_dropShadow_258_5665",
    result: "effect2_dropShadow_258_5665"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.24 0"
  }), React.createElement("feBlend", {
    in2: "effect2_dropShadow_258_5665",
    result: "effect3_dropShadow_258_5665"
  }), React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: -1
  }), React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.407843 0 0 0 0 0.937255 0 0 0 0.03 0"
  }), React.createElement("feBlend", {
    in2: "effect3_dropShadow_258_5665",
    result: "effect4_dropShadow_258_5665"
  }), React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect4_dropShadow_258_5665",
    result: "shape"
  }))));
}
const FlightsFillGreenOnBlue = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(FlightsFillGreenOnBlue);
export default Memo;